// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2Ofq8","footer":"ModalCreateQualiphyProcedure_footer__-A5mS","additionData":"ModalCreateQualiphyProcedure_additionData__jq8I_"};